import {AiFeatureType} from 'nutshell-graphql-types';

import {appHistory} from '../../history';

import {NutshellIqUsageFooter} from '../marketing/nutshell-iq-usage-footer';

import {AiCreditUsageFooter} from './ai-credit-usage-footer';

export function SidebarFooter() {
    const pathname = appHistory.location.pathname;
    const showNutshellIqFooter = pathname.includes('prospectoriq');
    const showAiCreditUsageFooter =
        pathname.includes('zoom') ||
        pathname.includes('/meet/') ||
        pathname.includes('teams') ||
        pathname.includes('calls');

    function getAiFeatureTypeFromPath(pathname: string): AiFeatureType {
        if (pathname.includes('zoom')) return AiFeatureType.ZOOM_NOTETAKER;
        if (pathname.includes('/meet/')) return AiFeatureType.GOOGLE_MEET_NOTETAKER;
        if (pathname.includes('teams')) return AiFeatureType.MICROSOFT_TEAMS_NOTETAKER;
        if (pathname.includes('calls')) return AiFeatureType.CLICK_TO_CALL_NOTETAKER;

        return AiFeatureType.ZOOM_NOTETAKER;
    }

    switch (true) {
        case showNutshellIqFooter:
            return <NutshellIqUsageFooter />;
        case showAiCreditUsageFooter:
            return <AiCreditUsageFooter aiFeatureType={getAiFeatureTypeFromPath(pathname)} />;
        default:
            return null;
    }
}
